import { config, axiosInstance } from "../axios";
import { URL_API_GEO } from "../urls";
import * as api from "./openapi";

export const apiGeo = {
  GEO: new api.GeoCodingApi(config, URL_API_GEO, axiosInstance),
};
